import { BookingsVisibility } from "PFApp/booking/types/bookings_visibility";
import { PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { BookingCategory, CalendarRange, Id } from "PFTypes";

import { appendCategoryRowsToLastPage } from "./get_profile_roles_request.utils";
import { PER_PAGE, RequestData } from "./get_request_data";

export const getProfileRolesRequest = (
  id: Id,
  dateRange: CalendarRange,
  bookingCategories: BookingCategory[],
  bookingsVisibility: BookingsVisibility | null
): RequestData => ({
  url: "booking_module/booked_activities",
  params: {
    perPage: bookingsVisibility === BookingsVisibility.CurrentZoom ? PER_PAGE_UNPAGINATED : PER_PAGE,
    profileId: id,
    dateRange
  },
  childrenType: "activity",
  mapResponse: appendCategoryRowsToLastPage({ profileId: id as number, dateRange, bookingCategories })
});
